import { useEffect, useState } from "react";
import { IMask, useIMask } from 'react-imask';
import Input from "../Input/Input";

function InputDate({ value, ...props }) {
	const [opts, setOpts] = useState({
		mask: 'd/m/Y H:M',
		blocks: {
			d: {
				mask: [
					{
						mask: IMask.MaskedRange,
						from: 1,
						to: 31,
						maxLength: 2
					},
					{
						mask: /^[*]$/
					}
				]
			},
			m: {
				mask: [
					{
						mask: IMask.MaskedRange,
						from: 1,
						to: 12,
						maxLength: 2
					},
					{
						mask: /^[*]$/
					}
				]
			},
			Y: {
				mask: [
					{
						mask: IMask.MaskedRange,
						from: 1900,
						to: 2999,
						maxLength: 4
					},
					{
						mask: /^[*]$/
					}
				]
			},
			H: {
				mask: [
					{
						mask: IMask.MaskedRange,
						from: 0,
						to: 23,
						maxLength: 2
					},
					{
						mask: /^[*]$/
					}
				]
			},
			M: {
				mask: [
					{
						mask: IMask.MaskedRange,
						from: 0,
						to: 59,
						maxLength: 2
					},
					{
						mask: /^[*]$/
					}
				]
			}
		}
	});

	const {
		ref,
		setValue,
	} = useIMask(opts, {
		onAccept: (value) => {
			props.onChange({ target: { value } })
		},
	});

	useEffect(() => {
		setValue(value)
	}, [value])

	return (
		<input type="text" {...props} ref={ref} />
	)
}

export default InputDate;